import { useContext } from "react";
import { AppContext } from "../state";

export function useIsNoc() {
  const { user } = useContext(AppContext);

  return user?.role?.toLowerCase() === "noc";
}